import axios from "axios";
import {
  CacheKeysResults,
  CacheSnapshot,
  CacheWarmingResult,
} from "./cache-types";
import config from "../../config";

const apiUrl = config.api;

export const getCacheKeys = async (): Promise<CacheKeysResults> => {
  const response = await axios.get<CacheKeysResults>(`${apiUrl}/cache/keys`);

  return response.data;
};

export const deleteCacheKey = async (
  key: string,
): Promise<CacheKeysResults> => {
  const response = await axios.delete<CacheKeysResults>(
    `${apiUrl}/cache/${key}`,
  );

  return response.data;
};

export const getCacheSnapshot = async (): Promise<CacheSnapshot> => {
  const response = await axios.get<CacheSnapshot>(`${apiUrl}/cache/snapshot`);

  return response.data;
};

export const warmCache = async (): Promise<CacheWarmingResult> => {
  const response = await axios.post<CacheWarmingResult>(`${apiUrl}/cache/warm`);

  return response.data;
};

export const purgeAllCache = async (): Promise<void> => {
  await axios.delete(`${apiUrl}/cache`);
};

// Keys and tags can contain characters such as ":" - the backend URL-decodes them.
export const purgeCacheKey = async (key: string): Promise<void> => {
  await axios.delete(`${apiUrl}/cache/${encodeURIComponent(key)}`);
};

export const purgeCacheTag = async (tag: string): Promise<void> => {
  await axios.delete(`${apiUrl}/cache/tag/${encodeURIComponent(tag)}`);
};
